The candidate for the given `id`.

This will include the candidate's personal details along with all application profiles for a single hirer.
